module.exports = __webpack_public_path__ + "static/img/smrz.7f6373f4.png";